// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarLayout_root__d94Sj","header":"SidebarLayout_header__szwlA","container":"SidebarLayout_container__hqrjW"};